import styled from 'styled-components';
import { Button } from 'components/atoms/button/button';
import {
  BackgroundColor,
  Height,
  InputBorder,
  InputFocus,
} from 'components/atoms/input/input';
import { Fields, Select } from 'components/organisms/tasks/criteria/components';
import { AdvancedFilterComponent } from 'components/organisms/tasks/filter-box/advanced';
import { Box } from 'components/organisms/tasks/filter-box/components';
import { AdvancedGroupedFilterComponent } from 'components/organisms/tasks/filter-box/grouped-advanced';

export const FilterComponent = styled(AdvancedFilterComponent)`
  margin-top: 20px;
`;

export const GroupedFilterComponent = styled(AdvancedGroupedFilterComponent)`
  margin-top: 20px;
`;

export const ContentHeader = styled.p`
  margin-bottom: '20px';
`;

export const FilterWrapper = styled(Box)`
  ${Fields} {
    ${BackgroundColor};
    ${InputBorder};
    ${Height};
    padding-left: 0;
    &.ant-select-open {
      ${InputFocus};
      .ant-select-selection-item {
        color: var(--gray-100);
      }
    }
    .ant-select-selector {
      ${Height};
      display: flex;
      align-items: center;
      padding-left: var(--spacing-05);
    }
  }
  ${Select} {
    padding-left: 0;
    .ant-select-selector {
      padding-left: var(--spacing-05);
    }
  }
`;

export const TagWrapper = styled.div`
  margin-right: var(--spacing-03);
  .ant-tag {
    margin: 0;
  }
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
`;

export const BadgeWrapper = styled(Flex)`
  flex: 1;
  flex-wrap: wrap;
  row-gap: var(--spacing-03);
`;

export const FilterTrigger = styled(Button)`
  padding-left: 0;
  padding-right: 0;
`;
